const state = (state = {}, action) => {
  switch (action.type) {
    case "LOAD_REPORTS_PAGE_PENDING":
      return { loading: true };
    case "LOAD_REPORTS_PAGE_FULFILLED":
      return { loading: false, ...action.payload };
    case "UPDATE_REPORTS_PAGE_PENDING":
      return { loading: true };
    case "UPDATE_REPORTS_PAGE_FULFILLED":
      return { loading: false, ...action.payload };
    default:
      return state;
  }
};

export default state;
